import Listener from '../../core/watcher/Listener'
import Element from '../../core/element/Element'
import ScrollYPointWatcher from '../../core/watcher/ScrollYPointWatcher'
import VisibilitySwitcherElement from '../../core/element/VisibilitySwitcherElement'
import EventEmitterManager from '../../core/event/EventEmitterManager'

import './_style.scss'

Listener.onLoad(() => {
   const selector = '.looking-for'
   if (document.querySelector(selector)) {
      new ScrollYPointWatcher(
         new Element(document.querySelector(selector)).getBottomPointRelativeToPage() - 60,
         EventEmitterManager.emitScrolledBelowLookingFor,
         EventEmitterManager.emitScrolledAboveLookingFor,
      )
   } else {
      console.log('selector "' + selector + '" is NULL')
   }

   const selectorFixed = '.looking-for--position-fixed'
   if (document.querySelector(selectorFixed)) {
      const lookingFor = new VisibilitySwitcherElement(document.querySelector(selectorFixed))
      EventEmitterManager.subscribeScrolledBelowLookingFor(lookingFor.show)
      EventEmitterManager.subscribeScrolledAboveLookingFor(lookingFor.hide)
      const lookingForBgImage = new VisibilitySwitcherElement(lookingFor.getElement().querySelector('.looking-for__img'))
      EventEmitterManager.subscribeScrolledBelowLookingFor(lookingForBgImage.show)
      EventEmitterManager.subscribeScrolledAboveLookingFor(lookingForBgImage.hide)
   } else {
      console.log('selector "' + selectorFixed + '" is NULL')
   }
})